import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface Notification {
  id: string;
  headline: string;
  content: string;
  active: boolean;
  notify: boolean;
  validFrom: string;
  validUntil: string;
}

@Component({
    selector: 'app-notifications-modal',
    imports: [CommonModule],
    templateUrl: './notifications-modal.component.html',
    styleUrls: ['./notifications-modal.component.scss']
})
export class NotificationsModalComponent {
  @Input() notifications: Notification[] = [];
  @Input() isOpen = false;
  @Output() closeModal = new EventEmitter<void>();

  onClose(): void {
    this.closeModal.emit();
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }
}
